import React, { useState } from 'react'

import { CopyInput } from '@components/common/CopyInput'

import * as S from './styled'

type Props = {
  rtmpsUrl: string
  srtUrl: string
  streamKey: string
}

export const LiveStreamKeys = ({ rtmpsUrl, srtUrl, streamKey }: Props) => {
  const [type, setType] = useState<'rtmps' | 'srt'>('rtmps')

  return (
    <S.Container>
      <S.Tabs>
        <S.Tab type="button" $active={type === 'rtmps'} onClick={() => setType('rtmps')}>
          RTMPS
        </S.Tab>
        <S.Tab type="button" $active={type === 'srt'} onClick={() => setType('srt')}>
          SRT
        </S.Tab>
      </S.Tabs>
      Copy URL and key and paste into your streaming software. Your video feed should appear here
      after connecting.
      <CopyInput
        label="Stream URL"
        buttonLabel="Copy"
        content={type === 'rtmps' ? rtmpsUrl : srtUrl}
      />
      {type === 'rtmps' && <CopyInput label="Stream key" buttonLabel="Copy" content={streamKey} />}
    </S.Container>
  )
}
